import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoConsultaPrestacaoContasAnual: ['administracao'],
    setMostraAplicarFiltroConsultaPrestacaoContasAnual: [],
    limpaFiltroConsultaPrestacaoContasAnual: [],
    aplicarFiltroConsultaPrestacaoContasAnual: ['filtro'],
})

const INITIAL_STATE = {
    exercicio: '',
    administracoes: [],
    mostraAplicarFiltro: false,
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracoes.splice(state.administracoes.indexOf(action.administracao), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.administracoes = Array.from(state.administracoes)
    return { ...state, mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_PRESTACAO_CONTAS_ANUAL]: removeAdministracao,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_PRESTACAO_CONTAS_ANUAL]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_PRESTACAO_CONTAS_ANUAL]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_PRESTACAO_CONTAS_ANUAL]: aplicarFiltro,
})
